import { Info } from '@project-lary/react-material-symbols';
import { Alert, AlertTitle } from '../../../design-system/ui/alert';

function TicketCreatedByColleaguesAlert({ creatorName }: { creatorName?: string }) {
  const alertText = `Diese Anfrage wurde von ${creatorName || 'Unbekannt'} erstellt, daher kannst du sie nur ansehen.`;

  return (
    <div className="w-full items-start">
      <Alert variant="warning">
        <div className="flex justify-center gap-4 text-accent-alpha-11">
          <div className="flex shrink-0 items-center justify-center">
            <Info />
          </div>
          <AlertTitle className="grow">{alertText}</AlertTitle>
        </div>
      </Alert>
    </div>
  );
}

export default TicketCreatedByColleaguesAlert;
